"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVideoId = exports.youtubePattern = void 0;
exports.youtubePattern = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/(watch\?v=)?([a-zA-Z0-9_-]{11})(&\S+)?$/;
const getVideoId = (url) => {
    const match = url.match(exports.youtubePattern);
    return match ? match[5] : null;
};
exports.getVideoId = getVideoId;
